
import Theme8 from "./Theme8";
import commonFunction from "../../lib/utils/common";
import Theme12 from "./Theme12";
import Theme13 from "./Theme13";

export function PaxComp(props) {
  const { theme } = props;

  console.log("PaxComptheme", props)

  switch (theme) {

    case "theme8":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Theme8 data={props} />
      );
      break;
       case "theme12":
      return (
       
      <Theme12 data={props} />
      );
      break;
       case "theme13":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Theme13 data={props} />
      );
      break;


    default:
      return <Theme8 data={props} />;
  }
}

export default PaxComp;
